import React, { useRef, useMemo,useCallback } from 'react'
import YouTube from 'react-youtube'
import { formatUrl } from '../utilities'
const VideoPlayer = ({ videoSrc, videoType, ...props }) => {
  const videoRef = useRef()
  const player_ref = useRef()
  const isYoutube = useMemo(() => videoSrc.includes('youtube'), [videoSrc])
  const repeatVideo = useCallback(()=>player_ref.current.internalPlayer.playVideo(),[player_ref])
  useMemo(() => {
    if (!isYoutube && videoRef.current) {
      if (videoRef?.current?.paused) {
        videoRef.current.play()
      }
    }
  }, [isYoutube, videoRef])
  const opts = {
    playerVars: {
      autoplay: 1,
      mute:1,
      controls: 0,
      modestbranding: 1,
      playsinline:1,
      loop:1,
      color: 'white'
    }
  }
  return isYoutube ? (
    <div className={props?.className || ''}>
      <YouTube
        ref={player_ref}
        className='yt-player w-full h-full max-h-svh'
        videoId={formatUrl(videoSrc)}
        muted
        opts={opts}
        loading='lazy'
        onEnd={repeatVideo}
      />
    </div>
  ) : (
    <video ref={videoRef} onClick={() => videoRef.current.play()} {...props}>
      <source src={videoSrc} type={videoType} />
    </video>
  )
}

export default VideoPlayer
